import React from 'react';
import i18n from '@leverege/i18n';
import { ToggleButton, Flex } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tfIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.widgets.Alignment');
export default function Alignment(props) {
  const {
    onChange,
    context: {
      editor
    }
  } = props;
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowS",
    children: [/*#__PURE__*/_jsx(ToggleButton, {
      title: t('leftAlign'),
      variant: "customTextAlignment|customText",
      value: editor.isActive({
        textAlign: 'left'
      }),
      icon: tfIcon('left', 'fa fa-align-left'),
      onChange: () => onChange('left', editor)
    }), /*#__PURE__*/_jsx(ToggleButton, {
      title: t('centerAlign'),
      variant: "customTextAlignment|customText",
      value: editor.isActive({
        textAlign: 'center'
      }),
      icon: tfIcon('center', 'fa fa-align-center'),
      onChange: () => onChange('center', editor)
    }), /*#__PURE__*/_jsx(ToggleButton, {
      title: t('rightAlign'),
      variant: "customTextAlignment|customText",
      value: editor.isActive({
        textAlign: 'right'
      }),
      icon: tfIcon('right', 'fa fa-align-right'),
      onChange: () => onChange('right', editor)
    })]
  });
}